import log from "loglevel";

export const validateEmail = (emailString) => {
  // TODO: SPLIT SEVERALEMAILS WITH ;
  log.info(`validateEmail @ inputValidations`);
  //let expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
  
  let expr = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    const emails = emailString.trim().split(';')
    log.info(`validateEmail @ inputValidations ${JSON.stringify(emails)}`);
    if (emails.lengh <1 ) return false;
    emails.forEach(_email => {
      if (!expr.test(_email)) {
        log.info(`validateEmail @ inputValidations - FAILED`);
        return false;
      }        
    });
    return true;
};

export const validateNumberOfItemsInPages = (n) => {
  log.info(`ValidateNumberOfPages @ inputValidations`);

  let d = /[1-9][0-9]/;
  if (d.test(n)) return true;

  return false;
};
